module.exports = __webpack_public_path__ + "media/images/background/profile-bg-e6ef5133af0a97542b04a6c214044b23.jpg";